module.exports = __webpack_public_path__ + "static/media/content-page-example.8c8c932c.gif";